import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    padding: 123px 0 103px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
`
export const Background = styled.div`
    width: 100%;
    background-color: white;
    padding: 35px 0 30px;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 35px 20px 30px;
    }
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`

export const SubWrapper = styled.div`
    max-width: 910px;
`
export const Text = styled.p`
    font-size: 17px;
    color: #777777;
    line-height: 1.66em;
    text-align: center;
    padding-top: 20px;
`
